import {BaseEntityUnDeletable} from '../../../common/entities';

export class InterviewStatus extends BaseEntityUnDeletable {
    description: string;
}
